import { LineString, Polygon } from 'ol/geom';
import type { Coordinate } from 'ol/coordinate';

export function measureDistance(coords: Coordinate[]): number {
  const line = new LineString(coords);
  return line.getLength();
}

export function measurePolylineLength(coords: Coordinate[]): number {
  const line = new LineString(coords);
  return line.getLength();
}

export function measureSegments(coords: Coordinate[]): number[] {
  const segments: number[] = [];
  for (let i = 1; i < coords.length; i++) {
    segments.push(measureDistance([coords[i - 1], coords[i]]));
  }
  return segments;
}

export function measureArea(coords: Coordinate[][]): number {
  const polygon = new Polygon(coords);
  return Math.abs(polygon.getArea());
}

export function measurePerimeter(coords: Coordinate[][]): number {
  const ring = coords[0];
  let perimeter = 0;
  for (let i = 1; i < ring.length; i++) {
    perimeter += measureDistance([ring[i - 1], ring[i]]);
  }
  return perimeter;
}

export function measureAngle(p1: Coordinate, vertex: Coordinate, p2: Coordinate): number {
  const a1 = Math.atan2(p1[1] - vertex[1], p1[0] - vertex[0]);
  const a2 = Math.atan2(p2[1] - vertex[1], p2[0] - vertex[0]);
  let angle = Math.abs((a1 - a2) * (180 / Math.PI));
  if (angle > 180) angle = 360 - angle;
  return angle;
}

export function toRealWorld(pixelValue: number, pixelsPerUnit: number): number {
  return pixelValue / pixelsPerUnit;
}

export function toRealWorldArea(pixelArea: number, pixelsPerUnit: number): number {
  return pixelArea / (pixelsPerUnit * pixelsPerUnit);
}

export function formatMeasurement(value: number, unit: string, isArea: boolean): string {
  const formatted = value < 10 ? value.toFixed(2) : value < 100 ? value.toFixed(1) : Math.round(value).toString();
  if (isArea) return `${formatted} ${unit}\u00B2`;

  // For linear ft measurements, also show total inches
  if (unit === 'ft' && !isArea) {
    const totalInches = value * 12;
    const inchFormatted = totalInches < 10 ? totalInches.toFixed(2) : totalInches < 100 ? totalInches.toFixed(1) : Math.round(totalInches).toString();
    return `${formatted} ft / ${inchFormatted} in`;
  }

  return `${formatted} ${unit}`;
}
